import { dispatchGtagEvent } from '../utils'

export const configureAdvancedSearchSubmit = () => {
  const form = document.querySelector('.advanced-search__form')
  if (!form) return
  form.addEventListener('submit', () => {
    dispatchGtagEvent('clicked_search_results')
  })
}